import { ref } from 'vue'
import axios from 'axios'
import qs from 'qs'
import { getToken } from '@/utils/auth'
import { message as Message } from 'ant-design-vue'

export default function useTableTools() {
  const Total = ref(0)
  const current = ref(1)
  const pageSize = ref(10)
  const TableData = ref([])

  // 列表数据导出方法
  const normalizeExport = (url, params, name, method = 'get') => {
    if (!url) return
    const headers = {
      token: getToken()
    }
    const axiosParams =
      method === 'get'
        ? {
            url: process.env.VUE_APP_BASE_API + url + '?' + qs.stringify(params),
            method: 'get'
          }
        : {
            url: process.env.VUE_APP_BASE_API + url,
            method: 'post',
            data: params
          }
    const requestParam = {
      responseType: 'blob',
      headers: headers,
      ...axiosParams
    }
    return axios(requestParam).then(res => {
      if (res.data.type === 'application/json') {
        const fileReader = new FileReader()
        let JsonRes
        fileReader.onloadend = () => {
          JsonRes = JSON.parse(fileReader.result)
          Message.error(JsonRes.msg || '下载失败')
        }
        fileReader.readAsText(res.data)
      } else {
        const blob = new Blob([res.data])
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, name + '.xlsx')
        } else {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = name + '.xlsx'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
        }
      }
    })
  }

  return { Total, current, pageSize, TableData, normalizeExport }
}
